module.exports = __webpack_public_path__ + "static/media/Logo_6.56d6f26d.png";